module.exports = __webpack_public_path__ + "img/img15.8ab3d7f8.svg";